<template>
  <div class="main">
    <div class="middle">
      <div class="loginBox">
        <router-link v-if="!getters.user" :to="{ name: 'login' }">
          <span>登录</span>
        </router-link>
        <el-dropdown v-if="!getters.user" style="margin-left:20px;">
          <span class="el-dropdown-link" style="color:#1890ff;">
            注册
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item style="padding:0 20px;">
              <router-link :to="{ name: 'registerComUser' }">成员注册</router-link>
            </el-dropdown-item>
            <el-dropdown-item style="padding:0 20px;">
              <router-link :to="{ name: 'registerUser' }">用户注册</router-link>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <a v-if="getters.user" @click="loginOut">退出</a>
      </div>
      <div class="logoBox">
        <img src="@/assets/img/logo.png" width="90px" height="90px" />
        <p class="name">
          <img src="@/assets/img/name.png" />
        </p>
      </div>
      <div class="search">
        <el-input class="searchEl" placeholder="请输入关键词" @change="search" v-model="searchKey">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="nav">
        <menu-nav />
      </div>
      <div class="contentBox">
        <router-view />
      </div>
    </div>
    <footer-box />
  </div>
</template>

<script>
import { menuItem_qy, login } from "@/api/home";
import menuNav from "@/components/menuNav";
import footerBox from "@/components/footerBox";
const getCookie = (name) => {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null;
};
const delCookie = (name) => {
  var exp = new Date();
  exp.setTime(exp.getTime() - 60 * 60 * 1000 * 24);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie =
      name + "=" + cval + ";expires=" + exp.toGMTString() + ";path=/";
};
export default {
  components: {
    menuNav,
    footerBox,
  },
  data() {
    return {
      searchKey: undefined,
      getters: this.$store.getters,
    };
  },
  methods: {
    search(val) {
      if (!val) {
        return;
      }
      let routerJump;

      routerJump = this.$router.resolve({
        name: "searchPage",
        query: {
          wd: val,
        },
      });

      window.open(routerJump.href, "_blank");
    },
    loginOut() {
      this.$confirm("确定退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          login({ op: "login", doLogin: 0 }).then((res) => {
            delCookie("password");
            delCookie("organFlag");
            delCookie("userCode");
            delCookie("loginType");
            this.$message({
              showClose: true,
              message: "退出成功",
            });
            window.location.reload();
            //this.$store.dispatch("getUser", {});
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  background: url("~@/assets/img/bg.png") no-repeat;
  background-size: 100% 650px;
  .middle {
    width: 1200px;
    margin: 0 auto;
    .loginBox {
      height: 50px;
      line-height: 50px;
      text-align: right;
      font-size: 14px;
      .line {
        padding: 0 10px;
      }
    }
    .logoBox {
      text-align: center;
      img {
        margin-bottom: 10px;
      }
      .name {
        font-size: 32px;
      }
    }
    .search {
      margin: 0 auto;
      width: 600px;
      margin-bottom: 50px;

      .searchEl {
        background: none;
        /deep/i {
          color: rgb(102, 102, 102);
          font-size: 20px;
          line-height: 50px;
          width: 40px;
        }
        /deep/input {
          background: rgba(255, 255, 255, 0.5);
          height: 50px;
          line-height: 50px;
          border-radius: 25px;
          text-align: center;
          font-size: 14px;
        }
        /deep/input::-webkit-input-placeholder {
          color: rgb(102, 102, 102);
        }
        /deep/input::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: rgb(102, 102, 102);
        }
        /deep/input:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: rgb(102, 102, 102);
        }
        /deep/input:-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: rgb(102, 102, 102);
        }
      }
    }
    .nav {
      margin-bottom: 20px;
    }
    .contentBox {
      background: #fff;
      border-radius: 10px;
      padding: 20px;
      box-shadow: 0 0 8px 2px #ddd;
      margin-bottom: 60px;
    }
  }
}
</style>